import React, { useState, useEffect } from "react";
import { Check, PriorityHigh, Clear, Close } from "@mui/icons-material";

const TOAST_TYPE = Object.freeze({
  SUCCESS: "success",
  WARNING: "warning",
  ERROR: "error",
});

export default function Toast({ type, header, message, position, onClose }) {
  const displayToastIcon = () => {
    switch (type) {
      case TOAST_TYPE.SUCCESS:
        return (
          <div className="toast-icon" style={{ backgroundColor: "#16a34a" }}>
            <Check fontSize="8px" />
          </div>
        );
      case TOAST_TYPE.WARNING:
        return (
          <div className="toast-icon" style={{ backgroundColor: "#f59e0b" }}>
            <PriorityHigh fontSize="8px" />
          </div>
        );
      case TOAST_TYPE.ERROR:
        return (
          <div className="toast-icon" style={{ backgroundColor: "#ef4444" }}>
            <Clear fontSize="8px" />
          </div>
        );
    }
  };

  return (
    <ToastContainer type={type} position={position}>
      {displayToastIcon()}
      <div className="toast-content">
        <h1>{header}</h1>
        {message && <p>{message}</p>}
      </div>

      {onClose && (
        <button onClick={onClose}>
          <Close className="toast-close-btn" />
        </button>
      )}
    </ToastContainer>
  );
}

function ToastContainer({ type, position, children }) {
  const [toastTheme, setToastTheme] = useState({});

  useEffect(() => {
    const newTheme = {};

    switch (position) {
      case "top-left":
        newTheme.top = 20;
        newTheme.left = 30;
        break;
      case "top-right":
        newTheme.top = 20;
        newTheme.right = 30;
        break;
      case "bottom-left":
        newTheme.bottom = 20;
        newTheme.left = 30;
        break;
      case "bottom-right":
        newTheme.bottom = 20;
        newTheme.right = 30;
        break;
      default:
        newTheme.bottom = 20;
        newTheme.right = 30;
        break;
    }

    switch (type) {
      case TOAST_TYPE.SUCCESS:
        newTheme.borderLeft = "0.5rem solid #16a34a";
        break;
      case TOAST_TYPE.WARNING:
        newTheme.borderLeft = "0.5rem solid #f59e0b";
        break;
      case TOAST_TYPE.ERROR:
        newTheme.borderLeft = "0.5rem solid #ef4444";
        break;
    }

    setToastTheme(newTheme);
  }, []);

  return (
    <span className="toast-container" style={toastTheme}>
      {children}
    </span>
  );
}
